var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibility = function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.917,
    d: "M1.79 11.845c-1.4-.64-.94-2.712.599-2.712l8.944.728 8.985-.728c1.541 0 2.001 2.072.599 2.712l-6.39 2.488 3.378 10.776c.155.34.168.727.036 1.077s-.397.634-.74.792a1.45 1.45 0 0 1-1.09.05 1.43 1.43 0 0 1-.811-.719l-3.968-6.757-3.967 6.757a1.43 1.43 0 0 1-.812.72 1.45 1.45 0 0 1-1.09-.05 1.43 1.43 0 0 1-.739-.793 1.4 1.4 0 0 1 .036-1.077l3.379-10.776zM13.889 4.111a2.556 2.556 0 1 1-5.111 0 2.556 2.556 0 0 1 5.11 0"
  })));
};
export default SvgAccessibility;